import type { Metric } from "web-vitals";

export interface MetricRecord {
  metricId: string;
  sequence: number;
  name: Metric["name"];
  value: number;
  rating: Metric["rating"];
  path: string;
  version: string;
  connection: string;
}

// 本例统计完整页面访问，不启用 soft navigation。归属用指标提供的 URL，
// 旧浏览器未提供时才退回这次文档加载的入口；不读回调发生时的当前路由。
export function metricRecord(metric: Metric, sequence: number, context: { entryURL: string; version: string; connection: string }): MetricRecord {
  const url = new URL(metric.navigationURL || context.entryURL, context.entryURL);
  return {
    metricId: metric.id,
    sequence,
    name: metric.name,
    value: metric.value,
    rating: metric.rating,
    path: url.pathname.replace(/^\/p\/[^/]+\/?$/, "/p/:slug"),
    version: context.version,
    connection: context.connection,
  };
}
